<template>
	<MStateBox :loading="custom.loading" :empty="isEmpty" class="ir-module-block">
		<SimpleHScroll class="report-list">
			<div class="report-container">
				<div class="report-wrapper" v-for="(item, index) in pageData" :key="index" @click="handleClick(item)">
					<img v-if="isPdfFile(item)" class="report-cover" :src="covers[item.fileUrl]" alt="" />
					<img v-else class="report-cover" :src="item.logoUrl" alt="" />
					<p class="report-title">{{ item.subject }}</p>
				</div>
			</div>
		</SimpleHScroll>
	</MStateBox>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import MStateBox from '@/view/enterprise_rebuild/components/MStateBox.vue';
import { SimpleHScroll } from '@rebuild/components/scroll';
import { useCustomCore } from '@rebuild/materials/shared/custom/context';
import { getPDFCover } from '@/utils/api';

const props = defineProps({
	moduleData: {
		type: Object,
		default: () => {
			return {};
		}
	}
});

const { getRealModuleId } = useCustomCore();
const getModuleId = computed(() => {
	return getRealModuleId(props.moduleData.moduleId);
});

const { custom } = useModuleData();
const { viewModule } = useModuleNavigation();

// 根据历史组件的数据访问路径：res?.rows
const pageData = computed(() => {
	return (custom.data?.rows || []).slice(0, 3);
});

// 空状态判断
const isEmpty = computed(() => {
	return custom.empty || !pageData.value?.length;
});

const isPdfFile = item => {
	const { fileUrl, type } = item;
	if (type != 1) return false;
	return fileUrl.endsWith('.pdf');
};

const { findModule } = useCustomCore();
const handleClick = item => {
	const findModuleData = findModule(getModuleId.value);
	viewModule('custom', item, findModuleData.name);
};
const covers = ref({});

async function refresh(done) {
	// 使用与历史组件相同的参数名称和值
	await custom.refresh({
		moduleId: getModuleId.value,
		pageStart: 0,
		pageNum: 20
	});
	let data = custom.data?.rows?.slice(0, 3) || [];
	data.forEach(item => {
		if (!item.fileUrl) return;
		getPDFCover(item.fileUrl).then(cover => {
			covers.value = Object.assign({}, covers.value, { [item.fileUrl]: cover });
		});
	});

	done && done();
}

onMounted(() => {
	refresh();
});
</script>

<style lang="less" scoped>
.report-list {
	width: 100%;
	overflow-x: scroll;

	&::-webkit-scrollbar {
		display: none;
		/* background-color:transparent; */
	}

	.report-container {
		display: inline-flex;
	}

	.report-wrapper {
		flex-shrink: 0;
		width: 1.2rem;

		.report-cover {
			width: 100%;
			height: 1.7rem;
			border: 1px solid var(--border-lighter-color);
		}
		.report-title {
			margin-top: 0.12rem;
			color: #333;
			font-family: 'PingFang SC';
			font-size: 0.14rem;
			font-style: normal;
			font-weight: 500;
			line-height: 0.18rem;
			white-space: pre-wrap;
		}
	}
	.report-wrapper + .report-wrapper {
		margin-left: 0.08rem;
	}
}
</style>
